export const DynataStatus = {
  "0-0": "An unknown state was reached or an error was encountered.",
  "0-1": "The language query parameter is missing in the inbound url.",
  "0-2": "The respondent ID query parameter is missing in the inbound url.",
  "0-3": "The respondent declined to give consent.",
  "0-4":
    "The respondent does not meet the minimum age requirement to participate in surveys for this country.",
  "0-5": "The provided country/language combination is not valid.",
  "0-6": "The country is not valid.",
  "0-7": "The language is not valid.",
  "0-8": "The respondent is not active.",
  "0-9":
    "The respondent was not found. Respondent may have deleted due to inactivity, or quality reasons.",
  "0-10": "The respondent’s birth date is invalid.",
  "1-0": "The respondent completed the entire client survey.",
  "1-1":
    "The respondent completed enough of the client survey to qualify as a complete.",
  "2-1": "The respondent was disqualified by Dynata.",
  "2-2": "The respondent was disqualified by the client survey.",
  "2-3": "The respondent's country did not match the opportunity's targeting.",
  "2-4": "The respondent's language did not match the opportunity's targeting.",
  "2-5": "The respondent's device did not match the opportunity's targeting.",
  "2-6":
    "The respondent disqualified because they did not match the opportunity's filtering criteria.",
  "2-10": "Partner is not assigned to quota group.",
  "3-0": "The targeted quota is full.",
  "3-1":
    "The respondent qualified for a full quota and was terminated by Dynata.",
  "3-2":
    "The respondent qualified for a full quota and was terminated by the client survey.",
  "3-3": "The respondent qualified for a quota that is closed.",
  "3-10": "The targeted quota group is paused or closed.",
  "3-11": "The targeted quota group is closed due to field schedule.",
  "3-12": "The targeted quota group is closed to maintain click balance.",
  "3-20": "The targeted quota cell is paused or closed.",
  "3-21": "The targeted quota cell is closed due to field schedule.",
  "3-22": "The targeted quota cell is closed to maintain click balance.",
  "4-0": "The respondent already participated in the client survey.",
  "4-1": "Duplicate based on respondent ID.",
  "4-2": "Duplicate based on category exclusion.",
  "4-3": "Duplicate based on project exclusion.",
  "4-4": "The respondent has already participated in this project.",
  "5-0": "The respondent was disqualified by Dynata due to quality reasons.",
  "5-1":
    "The respondent was disqualified by Dynata due to their answer quality.",
  "5-2":
    "The respondent was disqualified by Dynata due to inadequate time spent on questions.",
  "5-3": "The respondent was disqualified by Dynata due to suspension.",
  "5-4":
    "The respondent has been suspended by the client. Do not resend the respondent to this client’s projects.",
  "5-5": "The respondent’s IP did not match their region or country.",
  "5-10": "The respondent has reached their daily limit for completes.",
  "5-11":
    "The respondent was disqualified due to the high likelihood that the survey would result in a reconciliation with the client.",
  "5-20":
    "Respondent terminated due to high concentration of partner traffic driven to project. Pause all traffic to this project.",
  "2-7":
    "The respondent disqualified because they did not match the opportunity's quota criteria.",
  "2-8": "A quota group contains a hidden filter.",
};
